<template>
  <router-view></router-view>
</template>

<script>



export default {
  components: {
  },
  data: () => ({
  }),
};
</script>

<style>

/* Para aplicar a fonte geral "Urbane Rounded" */
* {
  font-family: 'Urbane Rounded', sans-serif;
}

</style>
